import React from 'react';

// 権限をマッピングする関数
export const getRoleName = (role) => {
  switch (parseFloat(role)) {
    case 9.5:
      return "アドミニストレータ";
    case 9.0:
      return "管理者";
    case 5.5:
      return "責任者（代表）"
    case 5.0:
      return "責任者";
    case 1.0:
      return "利用者";
    default:
      return "不明";
  }
};

// ユーザー権限をバッジとして表示するコンポーネント
const UserRoleBadge = ({ role }) => {
  return <span className="role-badge">{getRoleName(role)}</span>;
};

export default UserRoleBadge;
